// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

import { LitElement, html, css, PropertyValues } from 'lit';
import { customElement, property, state, query } from 'lit/decorators.js';
import { ControlHint } from './control-hints.js';

interface NavigationItem {
	id: string;
	title: string;
	icon: any;
	content: any;
	hasIndicator?: boolean;
}

@customElement('device-page')
export class DevicePage extends LitElement {
	@property({ type: Array })
	private navigationItems: NavigationItem[] = [
		{
			id: 'device-id',
			title: 'Device Identity',
			icon: html`\
<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFA500">
	<path d="M200-40v-40q0-139 58-225.5T418-480q-102-88-160-174.5T200-880v-40h80v40q0 11 .5 20.5T282-840h396q1-10 1.5-19.5t.5-20.5v-40h80v40q0 139-58 225.5T542-480q102 88 160 174.5T760-80v40h-80v-40q0-11-.5-20.5T678-120H282q-1 10-1.5 19.5T280-80v40h-80Zm138-640h284q13-19 22.5-38t17.5-42H298q8 22 17.5 41.5T338-680Zm142 148q20-17 39-34t36-34H405q17 17 36 34t39 34Zm-75 172h150q-17-17-36-34t-39-34q-20 17-39 34t-36 34ZM298-200h364q-8-22-17.5-41.5T622-280H338q-13 19-22.5 38T298-200Z"/>
</svg>`,
			content: 'blaa blaa'
		},
		{
			id: 'access-token',
			title: 'Access Token',
			icon: html`\
<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFA500">
	<path d="M480-80 120-280v-400l360-200 360 200v400L480-80ZM364-590q23-24 53-37t63-13q33 0 63 13t53 37l120-67-236-131-236 131 120 67Zm76 396v-131q-54-14-87-57t-33-98q0-11 1-20.5t4-19.5l-125-70v263l240 133Zm40-206q33 0 56.5-23.5T560-480q0-33-23.5-56.5T480-560q-33 0-56.5 23.5T400-480q0 33 23.5 56.5T480-400Zm40 206 240-133v-263l-125 70q3 10 4 19.5t1 20.5q0 55-33 98t-87 57v131Z"/>
</svg>`,
			content: html`\
<pre>eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ik9NSDB0ZGg5SE1
0cEh5dXZRY1A5NyJ9.eyJpc3MiOiJodHRwczovL2Rldi0yaGRkemgxamtua
nJpdjZnLnVzLmF1dGgwLmNvbS8iLCJzdWIiOiJhdXRoMHw2NTdmMzBmYzA3
Njc1YjljN2VmODk1NWMiLCJhdWQiOlsiaHR0cHM6Ly9tZWxhbmllLmRzYnV
ubnkuY29tIiwiaHR0cHM6Ly9kZXYtMmhkZHpoMWprbmpyaXY2Zy51cy5hdX
RoMC5jb20vdXNlcmluZm8iXSwiaWF0IjoxNzU2OTU0NzMzLCJleHAiOjE3N
TcwNDExMzMsInNjb3BlIjoib3BlbmlkIHRlbmFudDoxZmYyZGQwZS00YzZj
LTRhOGUtYWRkMy1kMmY3OTllN2QzNjQgYXBpOnJlYWQgYXBpOndyaXRlIG9
mZmxpbmVfYWNjZXNzIiwiYXpwIjoiMlF3cHdXQ1lFdjZqTlNZdzBTM2Fkc3
NDaWRyTUtQSTYifQ.EH3a6UYb3MVPkgz4PZfXsT-3Da8yCox3mbMfcn4ZNQ
4fKvxTStEKnHrjQhCMxgKeHmqEIx5Vo6IUsgMcc57L3ymddaoFnDcb649Ju
m0yITxMnbFxlxR-00js_4_0ehi5DvBD-10sbSzG3qVTzvuR8RUY4u88v4l3
ICFo06ZAJvsL_SjEjXzjsuwFoiC5KxE54zkcNxmHbOCRkQKp147k3y4K4h-
kZOfjjYv_CPX35TObFJ1kGJwMCIRhB1dZJDIOHVMRDw6QSN08MWgebrvrVf
D1WhvMXnf4jpqD8-_xsn53s3aWmUYz6Ur7LfBbAAY-4SCnkJ6zzqOhHsaFs
Pe28w</pre>`,
			hasIndicator: true,
		},
		{
			id: 'refresh-token',
			title: 'Refresh Token',
			icon: html`\
<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFA500">
	<path d="M480-80 120-280v-400l360-200 360 200v400L480-80ZM364-590q23-24 53-37t63-13q33 0 63 13t53 37l120-67-236-131-236 131 120 67Zm76 396v-131q-54-14-87-57t-33-98q0-11 1-20.5t4-19.5l-125-70v263l240 133Zm40-206q33 0 56.5-23.5T560-480q0-33-23.5-56.5T480-560q-33 0-56.5 23.5T400-480q0 33 23.5 56.5T480-400Zm40 206 240-133v-263l-125 70q3 10 4 19.5t1 20.5q0 55-33 98t-87 57v131Z"/>
</svg>`,
			content: 'blaa blaa'
		}
	];

	@state()
	private selectedIndex = 0;

	@state()
	private controlHints: ControlHint[] = [
		{ key: 'Esc', hint: 'Exit' },
	];

	static override styles = css`\
:host {
	display: block;
	font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
	color: #e2e8f0;
	min-height: 300px;
	position: relative;
	overflow: hidden;
	outline: none;  /* Override default focus outline */
}

.container {
	display: flex;
	height: 100%;
}

.navigation {
	display: flex;
	height: fit-content;
}

nav {
	width: 460px;
	padding: 20px;
}

.nav-item {
	display: flex;
	align-items: center;
	padding: 12px 16px;
	margin-bottom: 8px;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.2s ease;
	background: rgba(226, 232, 240, 0.1);
    	border: 2px solid rgba(226, 232, 240, 0.2);
	position: relative;
}

.nav-item:hover {
	border-color: rgb(66 153 225);
}

.nav-item.selected {
	background: rgb(255, 255, 255);
	box-shadow: rgb(33, 150, 243) 0px 0px 10px 3px;
}

.nav-icon {
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 12px;
	font-size: 12px;
	font-weight: bold;
	color: #1a1a1a;
}

.nav-item.selected .nav-icon {
	color: white;
}

.nav-content {
	flex: 1;
}

.nav-indicator {
	position: absolute;
	top: 1em;
	right: 1em;
	width: 8px;
	height: 8px;
	background: #ff4444;
	border-radius: 50%;
	box-shadow: 0 0 8px rgba(255, 68, 68, 0.6);
	animation: glow 1s ease-in-out infinite alternate;
}

@keyframes glow {
	0% {
		background: #ff4444;
		box-shadow: 0 0 8px rgba(255, 68, 68, 0.6);
	}
	100% {
		background: #ffd7ca;
		box-shadow: 0 0 5px 2px rgba(255, 102, 0, 0.8), 0 0 30px rgba(255, 102, 0, 0.4);
	}
}

.nav-title {
	font-size: 14px;
	font-weight: 600;
	margin-bottom: 2px;
	color: rgba(226, 232, 240, 0.6);
}

.nav-item.selected .nav-title {
	color: #000;
}

.control-hints {
	display: flex;
    	flex-direction: column;
    	align-items: center;
    	justify-content: flex-end;
	margin-bottom: 28px;
}

.key-binding {
	width: 20px;
	height: 20px;
	background: rgba(226, 232, 240, 0.1);
	border: 1px solid rgba(226, 232, 240, 0.2);
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 11px;
	font-weight: bold;
}

.nav-item.selected .key-binding {
	background: rgba(66, 153, 225, 0.3);
	border-color: #4299e1;
	color: #90cdf4;
}

.content-panel {
	flex: 1;
	padding: 20px;
	display: flex;
	flex-direction: column;
}

.content-header {
	font-size: 18px;
	font-weight: 600;
	color: #f7b731;
	margin-bottom: 20px;
	border-bottom: 1px solid rgba(247, 183, 49, 0.3);
	padding-bottom: 10px;
	width: 600px;
}

.content-text {
	font-size: 14px;
	line-height: 1.6;
	color: #cbd5e0;
}

@media (max-width: 768px) {
	.container {
		flex-direction: column;
	}

	.navigation {
		width: 100%;
	}

	.content-panel {
		min-height: 200px;
	}
}`;

	override connectedCallback() {
		super.connectedCallback();
		this.addEventListener('keydown', this.handleKeyDown);
		this.tabIndex = 0; // Make the component focusable
	}

	override disconnectedCallback() {
		super.disconnectedCallback();
		this.removeEventListener('keydown', this.handleKeyDown);
	}

	private handleKeyDown = (event: KeyboardEvent) => {
		switch (event.key) {
		case '1':
		case 'ArrowUp':
			event.preventDefault();
			this.navigateUp();
			break;
		case '3':
		case 'ArrowDown':
			event.preventDefault();
			this.navigateDown();
			break;
		}
	};

	private navigateUp() {
		this.selectedIndex = this.selectedIndex > 0 ? this.selectedIndex - 1 : this.navigationItems.length - 1;
	}

	private navigateDown() {
		this.selectedIndex = this.selectedIndex < this.navigationItems.length - 1 ? this.selectedIndex + 1 : 0;
	}

	private selectItem(index: number) {
		this.selectedIndex = index;
	}

	override render() {
		const selectedItem = this.navigationItems[this.selectedIndex];

		return html`\
<div class="container">
	<div class="navigation">
		<nav>
			${this.navigationItems.map((item, index) => html`
				<div
					class="nav-item ${index === this.selectedIndex ? 'selected' : ''}"
					@click=${() => this.selectItem(index)}
				>
					<div class="nav-icon">${item.icon}</div>
					<div class="nav-content">
						<div class="nav-title">${item.title}</div>
					</div>
					${item.hasIndicator ? html`<div class="nav-indicator"></div>` : ''}
				</div>
			`)}
		</nav>

		<div class="control-hints">
			<div class="key-binding">1</div>
			<div class="arrows">
				<svg width="24px" height="24px" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
					<!-- Triangle pointing up -->
					<polygon points="100,40 70,100 130,100" fill="white" stroke="none"/>

					<!-- Triangle pointing down -->
					<polygon points="70,120 130,120 100,180" fill="white" stroke="none"/>
				</svg>
			</div>
			<div class="key-binding">3</div>
		</div>
	</div>

	<div class="content-panel">
		<div class="content-header">${selectedItem.title}</div>
		<div class="content-text">${selectedItem.content}</div>
	</div>

	<control-hints
		.hints=${this.controlHints}
	></control-hints>
</div>`;
	}
}
